<!-- eslint-disable @typescript-eslint/no-magic-numbers -->
<script setup lang="ts">
    import WidgetCalendar from '@/components/WidgetCalendar.ce.vue';

    const props = defineProps<{
        modelValue: string;
    }>();

    // eslint-disable-next-line func-call-spacing
    const emit = defineEmits<{
        (event: 'update:modelValue', value: string): void
        (event: 'next'): void
    }>();

    const { t } = useI18n();

    const calendarModel = ref(props.modelValue ?? '');

    watch(() => calendarModel.value, (nVal: string) => {
        emit('update:modelValue', nVal);
    });
</script>

<template>
    <div class="date-selection">
        <div class="date-selection__calendar">
            <WidgetCalendar
                v-model="calendarModel"
                :offset-days="2"
            />
        </div>
        <button
            v-if="calendarModel"
            type="button"
            class="btn btn--primary date-selection__next"
            :class="{ 'btn--hidden': !calendarModel }"
            :disabled="!calendarModel"
            @click="emit('next')"
        >
            <span>
                {{ t('widget.buttons.next') }}
            </span>
        </button>
    </div>
</template>

<style lang="scss" scoped>
.date-selection {
    position: relative;
    display: flex;
    overflow: auto;
    flex-direction: column;
    align-items: center;
    block-size: 100%;
    gap: var(--spacing-04);
    inline-size: 100%;

    @include min-width(lg) {
        align-items: center;
        block-size: auto;
        margin-inline: auto;
        max-inline-size: 468px;
    }

    &__calendar {
        @include min-width(md) {
            padding-block-start: var(--spacing-08);
        }

        @include min-width(lg) {
            padding-block-start: 0;
        }
    }

    &__next {
        position: fixed;
        z-index: var(--zindex-stack-twice);
        align-self: center;
        inset-block-end: var(--spacing-05);
        inset-inline-start: 50%;
        min-inline-size: 174px;
        transform: translateX(-50%);

        @include min-width(lg) {
            position: static;
            align-self: flex-end;
            inset-inline: 0;
            inset-inline-start: 0;
            margin-block-end: var(--spacing-06);
            transform: none;
        }
    }
}
</style>
